var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsActivate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_activate_group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_activate_group2",
    transform: "translate(-1333.000000, -572.000000)",
    fill: "#515D75",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1343,572 L1341,572 L1341,582 L1343,582 L1343,572 Z M1347.83,574.17 L1346.41,575.59 C1347.99,576.86 1349,578.81 1349,581 C1349,584.87 1345.87,588 1342,588 C1338.13,588 1335,584.87 1335,581 C1335,578.81 1336.01,576.86 1337.58,575.58 L1336.17,574.17 C1334.23,575.82 1333,578.26 1333,581 C1333,585.97 1337.03,590 1342,590 C1346.97,590 1351,585.97 1351,581 C1351,578.26 1349.77,575.82 1347.83,574.17 Z",
    id: "icons_activate_path1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsActivate);
export default __webpack_public_path__ + "static/media/icons_activate.8838c208.svg";
export { ForwardRef as ReactComponent };